import { safeJsonDate } from '@utils';
import { Lead } from '$admin/interfaces/project';

export const transformProjectLead = (data: Lead.Item<string>): Lead.Item<Date> => {
  return {
    ...data,
    addedAt: safeJsonDate(data.addedAt),
  };
};